<template>
  <div id="navbar" class="navbar" :class="{ horizontalNavbar: style === 'horizontal' }">
    <!--<hamburger v-if="style === 'vertical'" id="hamburger-container" :is-active="sidebar.opened"-->
    <!--  class="hamburger-container" @toggleClick="toggleSideBar" />-->
    <!--<breadcrumb v-if="style === 'vertical'" id="breadcrumb-container" class="breadcrumb-container" />-->
    <div class="header">
      <div class="system_logo">
        <img src="@/assets/main_images/login_images/logo.png" alt="">
        <div class="system_name_en">China Automotive Material Data System</div>
      </div>
      <div class="system_name">中国汽车材料数据系统</div>
    </div>
    <div :class="{ horizontalSidebarContent: style === 'horizontal' }">
      <!-- <Sidebar v-if="style === 'horizontal'" :class="{ horizontalSidebar: style === 'horizontal' }" /> -->
      <SetUp :class="{ setUpHorizontal: style === 'horizontal' }" />
    </div>

    <breadcrumb v-if="style === 'horizontal'" class="breadcrumb-container-horizontal" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import ErrorLog from "@/components/ErrorLog";
import Sidebar from "@/layout/components/Sidebar";
import SetUp from "./setUp";
export default {
  data() {
    return {};
  },
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Sidebar,
    SetUp,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device"]),
    ...mapState({
      style: (state) => state.settings.style,
    }),
  },
  mounted() {
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 64px;
  //overflow: hidden;
  position: relative;
  background: url("../../assets/main_images/navbar/header_bg.png") no-repeat;
  @include background('menu-background2');
  background-size:360px 100%;
  background-position-x: -1px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  position: relative;
  display: flex;
  justify-content: space-between;

  .header {
    display: flex;
    align-items: center;
    //margin-top: 4.5vh;
    margin-left: -215px;
    color: #fff;
    font-size: 0;
    z-index: 1003;

    .system_logo {
      position: relative;
      img {
        width: 139px;
      }

      .system_name_en {
        position: absolute;
        font-size: 12px;
        white-space: nowrap;
        opacity: 0.8;
        margin-top: 2px;
      }
    }

    .system_name {
      font-size: 30px;
      line-height: 55px;
      letter-spacing: 5px;
      margin-left: 5px;
    }

    > div {
      margin-right: 10px;
    }
  }

  .hamburger-container {
    line-height: 64px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 64px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-wrapper {
      display: flex;
      align-items: center;
      margin-right: 20px;

      img {
        height: 26px;
        width: 26px;
        vertical-align: middle;
        margin-right: 10px;
      }

      .user-usname {
        color: #333333;
        font-size: 16px;
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 26px;
          height: 26px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }

        @media only screen and (max-width: 1366px) {
          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 18px;
            font-size: 12px;
          }
        }
      }
    }
  }
}

.breadcrumb-container-horizontal {
  position: absolute;
  bottom: 0px;
  line-height: 42px !important;
}

.daping {
  width: 26px;
  height: 26px;
  cursor: pointer;
}

.daping-container {
  line-height: 64px;

  img {
    line-height: 64px;
    vertical-align: middle;
  }
}
.horizontalSidebar {
  width: calc(100% - 230px);
  display: flex;
  height: 100%;
  justify-content: space-between;
}
.horizontalSidebarContent {
  height: 60px;
  background: #001431;
}
@media only screen and (max-width: 1366px) {
  .navbar {
    .header {
      margin-left: -200px;

      .system_logo {
        img {
          width: 120px;
        }
        .system_name_en {
          transform: scale(0.9);
          transform-origin: left top;
        }
      }

      .system_name {
        font-size: 24px;
        line-height: 38px;
        margin-left: 0px;
        letter-spacing: 1px;
      }
    }

    .hamburger-container {
      line-height: 50px;
    }
  }
}

.abow_dialog ::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.abow_dialog ::v-deep .el-dialog .el-dialog__body {
  padding: 0;
  padding-bottom: 10px;
  flex: 1 1 auto;
  overflow: auto;
}
</style>
